import { LocalStorage } from '@axiom/ui';
import type { Candidate } from '@axiom/validation';

const STORE_NAMES = {
  workFeedFilters: 'work_feed_filters',
  textMessageAlertsBannerDismissed: 'text_message_alerts_banner_dismissed',
};

export const localStorageUtil = {
  workFeedFilters: (
    candidateId: Candidate['id'],
    practiceAreas: string[] | null = [],
    focusAreas: string[] | null = [],
    countries: string[] | null = [],
    businessTitles: string[] | null = []
  ) => {
    if (!candidateId) {
      throw new Error('candidateId is required');
    }

    return LocalStorage(`${STORE_NAMES.workFeedFilters}:${candidateId}:v6`, {
      practiceAreas,
      focusAreas,
      countries,
      businessTitles,
    });
  },

  textMessageAlertsBannerDismissed: (candidateId: Candidate['id']) => {
    if (!candidateId) {
      throw new Error('candidateId is required');
    }

    return LocalStorage(
      `${STORE_NAMES.textMessageAlertsBannerDismissed}:${candidateId}:v1`,
      null
    );
  },
};
